<div
  aria-labelledby="headPrimary4"
  class="common-va-widget-bg"
  id="primaryPanel4"
  role="tabpanel"
>
  <div class="container flifo-widget-container container-padding-x">
    <form
      #formStoreDir="ngcFormStore"
      (ngSubmit)="onSubmit()"
      [formGroup]="flightStatusWidgetForm"
      [makeVisible]="isSubmitted"
      [ngClass]="{ 'pb-lg-5': this.errorHandler?.errorFields.length > 0 }"
      [ngc-form-store]="'flightStatusWidgetForm'"
      [ngc-formNameToValidate]="'flightStatusWidgetForm'"
      [ngc-formToValidate]="flightStatusWidgetForm"
      name="viewFlightStatus"
      ngc-error-handler
      novalidate
    >
      <ngc-make-correction></ngc-make-correction>
      <input id="FLIFO_target_airport_field" type="hidden" />
      <input id="FLIFO_contextPath" type="hidden" value="/widgetnav/" />
      <input
        id="FLIFO_requestingSite"
        name="requestingSite"
        type="hidden"
        value="polaris_athens"
      />
      <input
        [(ngModel)]="searchOptionValue"
        [ngModelOptions]="{ standalone: true }"
        id="FLIFO_searchOption"
        name="searchOptionValue"
        type="hidden"
      />
      <div
        [ngClass]="{
          'pt-sm-3 pt-md-3': this.errorHandler?.errorFields.length > 0
        }"
        class="form-row"
      >
        <div
          class="col-lg-3 order-1 offset-md-2 col-md-8 offset-lg-0 pl-xl-0 pl-xxl-0"
        >
          <label class="floatinglabel" for="searchBydate" id="searchBydateLbl">
            {{
              contentFlightStatus
                ? contentFlightStatus.searchByLabelFloat
                : 'Search by Date'
            }}
            (Required)
          </label>
          <date-selection-view
            [allowPreviousDay]="
              flightSearchStartDate && isSearchByFlightNumber ? 2 : 1
            "
            [checkJourneyType]="'oneway'"
            [defaultDepartDate]="defaultSearchDate"
            [displayDateFormat]="'eee/mmm/dd'"
            [formObj]="flightStatusWidgetForm"
            [formObject]="flightStatusWidgetForm"
            [index]="1"
            [showDefaultDate]="true"
            [travelType]="'Departure'"
            dateFor="searchBydate"
            departPlaceHolderText="{{
              contentFlightStatus
                ? contentFlightStatus.searchByLabel
                : 'Search by Date'
            }}"
            departlabelText="Search by date required"
            firstElement="true"
            floatingLbl="searchBydateLbl"
            name="flightDate"
            returnPlaceHolderText="Return"
            returnlabelText="Return"
            standaloneCal="true"
          ></date-selection-view>
          <ngc-validation-error-message
            [control]="flightStatusWidgetForm?.controls.departureDate"
            [controlname]="'departureDate'"
            [focusedFieldId]="'input_departureDate_1'"
            [index]="1"
            [makeVisible]="isSubmitted"
            [showErrorOnChange]="true"
          ></ngc-validation-error-message>
        </div>
        <div class="col-lg-3 order-2 offset-md-2 col-md-8 offset-lg-1">
          <input
            #FlightNumberValue="ngcFloatingLabelDirective"
            (keypress)="numberOnly($event)"
            (keyup)="onFlightnumberChange()"
            [attr.placeholder]="
              contentFlightStatus
                ? contentFlightStatus.flightNumber
                : 'Flight Number'
            "
            [ngc-floatinglabel]="
              contentFlightStatus
                ? contentFlightStatus.flightNumberLabelFloat
                : 'Flight Number'
            "
            [ngc-isRequired]="true"
            autocomplete="off"
            class="form-control mb-2 mb-sm-0 input-mobile-tab-class"
            formControlName="flightNumber"
            id="flightNo"
            name="flightNumber"
            ngc-floatinglabel
            type="{{
              contentFlightStatus
                ? contentFlightStatus.flightNumberType
                : 'number'
            }}"
            pattern="{{ contentFlightStatus?.flightstatusRegexPattern }}"
          />
          <ngc-validation-error-message
            [control]="flightStatusWidgetForm?.controls.flightNumber"
            [controlname]="'flightNumber'"
            [focusedFieldId]="'flightNo'"
            [makeVisible]="isSubmitted"
          ></ngc-validation-error-message>
          <ngc-validation-error-message
            [control]="flightStatusWidgetForm"
            [controlname]="'flightStatusWidgetForm'"
            [focusedFieldId]="'flightNo'"
            [makeVisible]="isSubmitted"
          ></ngc-validation-error-message>
        </div>
        <div
          class="col-lg-1 py-lg-2 mt-4 text-center order-3 offset-md-2 col-md-8 offset-lg-0"
        >
          <span class="flifo-wrapper-option align-middle">
            {{ contentFlightStatus ? contentFlightStatus.orLabel : 'or' }}
          </span>
        </div>
        <div
          class="col-lg-3 offset-md-2 col-md-8 col-sm-12 text-center offset-lg-0 order-4"
          formGroupName="airports"
        >
          <div class="row no-gutters flightStaus-to-from">
            <div
              class="col-lg-4 col-sm-4 col-md-5 order-1 text-lg-left text-center"
            >
              <a
                #deptAirportLookupDir="ngcAirportLookupDirective"
                (click)="deptAirportLookupDir?.openLookupModal(true)"
                (focusout)="onFocusOutFromAirport()"
                (keydown)="
                  $event.keyCode !== 13 &&
                  (($event.keyCode >= 65 && $event.keyCode <= 90) ||
                    ($event.keyCode >= 96 && $event.keyCode <= 105) ||
                    ($event.keyCode >= 48 && $event.keyCode <= 57))
                    ? deptAirportLookupDir?.openLookupModal(true)
                    : ''
                "
                (searchedAirportCode)="
                  fromAirport = $event; markAsTouchedFrom()
                "
                (selectedAirport)="
                  fromAirport = $event.airportCode;
                  fromCity = $event.city + ', ' + $event.region;
                  markAsTouchedFrom()
                "
                [currentNav]="'Flight-Status'"
                [initialLookupKey]="fromAirport"
                [lookupTitle]="'Origin'"
                [ngc-data-value]="fromAirport"
                [ngc-floatinglabel]="
                  contentFlightStatus
                    ? contentFlightStatus.fromLabelFloat
                    : 'From'
                "
                [ngc-isRequired]="true"
                [ngc-useDataValue]="true"
                [widgetOnTop]="widgetOnTop"
                aria-haspopup="true"
                class="departCity form-control no-underline text-center"
                href="javascript:void(0);"
                id="departcitylink"
                ngc-airport-lookup-directive
              >
                <span class="sr-only">Depart City required</span>
                <span
                  [ngClass]="{
                    'airport-desc': !fromAirport || fromAirport === ''
                  }"
                >
                  {{
                    fromAirport
                      ? fromAirport
                      : contentFlightStatus
                      ? contentFlightStatus.fromLabel
                      : 'From'
                  }}
                </span>
                <input
                  class="mb-2 mb-sm-0 text-center"
                  formControlName="fromAirport"
                  id="departCity"
                  name="departureAirport"
                  type="hidden"
                />
              </a>
            </div>
            <div
              class="col-lg-4 col-sm-4 col-md-5 order-3 text-lg-left text-center"
            >
              <a
                #toAirportLookupDir="ngcAirportLookupDirective"
                (click)="toAirportLookupDir?.openLookupModal(true)"
                (focusout)="onFocusOutToAirport()"
                (keydown)="
                  $event.keyCode !== 13 &&
                  (($event.keyCode >= 65 && $event.keyCode <= 90) ||
                    ($event.keyCode >= 96 && $event.keyCode <= 105) ||
                    ($event.keyCode >= 48 && $event.keyCode <= 57))
                    ? toAirportLookupDir?.openLookupModal(true)
                    : ''
                "
                (searchedAirportCode)="toAirport = $event; markAsTouchedTo()"
                (selectedAirport)="
                  toAirport = $event.airportCode;
                  toCity = $event.city + ', ' + $event.region;
                  markAsTouchedTo()
                "
                [currentNav]="'Flight-Status'"
                [initialLookupKey]="toAirport"
                [lookupTitle]="'Destination'"
                [ngc-data-value]="toAirport"
                [ngc-floatinglabel]="
                  contentFlightStatus ? contentFlightStatus.toLabelFloat : 'To'
                "
                [ngc-isRequired]="true"
                [ngc-useDataValue]="true"
                [widgetOnTop]="widgetOnTop"
                aria-haspopup="true"
                class="arrivalCity form-control no-underline text-center"
                href="javascript:void(0);"
                id="arrivalcitylink"
                ngc-airport-lookup-directive
              >
                <span class="sr-only">Arrival City required</span>
                <span
                  [ngClass]="{ 'airport-desc': !toAirport || toAirport === '' }"
                >
                  {{
                    toAirport
                      ? toAirport
                      : contentFlightStatus
                      ? contentFlightStatus.toLabel
                      : 'To'
                  }}
                </span>
                <input
                  class="mb-2 mb-sm-0 text-center"
                  formControlName="toAirport"
                  id="arrivalCity"
                  name="arrivalAirport"
                  type="hidden"
                />
              </a>
            </div>
            <div
              class="swap-container col-lg-4 col-sm-4 col-md-2 order-2 p-0 text-center"
            >
              <a
                (click)="swapCity()"
                class="swapfield icon-swap d-inline-block"
                href="javascript:void(0);"
                role="button"
                title="Reverse origin and destination city or airport"
              ></a>
            </div>
          </div>
          <ngc-validation-error-message
            [control]="flightStatusWidgetForm?.controls.airports"
            [controlname]="'airports'"
            [focusedFieldId]="fieldToFocus"
            [makeVisible]="isSubmitted"
          ></ngc-validation-error-message>
        </div>
        <div
          class="pr-lg-0 pr-xl-0 col-lg-1 text-right mt-4 mb-sm-4 mb-lg-0 order-12 offset-md-2 col-md-8 offset-lg-0 flight-status-submit-btn"
        >
          <button
            (click)="setTrackingObj($event)"
            [ngClass]="{
              'last-focusable-element':
                !contentFlightStatus?.helpUrl ||
                (contentFlightStatus &&
                  contentFlightStatus?.helpUrl &&
                  contentFlightStatus.helpUrl === '')
            }"
            class="btn btn-danger btn-right-arrow icon-submitarrow rounded-circle circle-outline"
            id="btn-flight-sts-submit"
            type="submit"
          >
            <span class="sr-only">Submit</span>
          </button>
        </div>
      </div>
      <div *ngIf="contentFlightStatus?.helpUrl" class="form-row">
        <div
          class="col-lg-auto resrv-link-col offset-md-2 col-md-6 col-sm-10 offset-lg-0 pl-xl-0 mb-lg-1 mt-lg-3"
        >
          <a
            [attr.href]="
              contentFlightStatus
                ? contentFlightStatus.helpUrl
                : 'https://www.virginatlantic.com/'
            "
            [attr.target]="''"
            [ngClass]="{
              'last-focusable-element':
                contentFlightStatus && contentFlightStatus.helpUrl !== ''
            }"
            class="hotel-resrv-link icon-Dropdown-caret"
          >
            {{
              contentFlightStatus
                ? contentFlightStatus.helpLabel
                : 'Flight status help'
            }}
            <!-- <span class="sr-only" *ngIf="contentMyTrip ?.mytripsHotelreservationTarget==='on'">opens in new window</span> -->
          </a>
        </div>
      </div>
    </form>
  </div>
</div>
